<template>
	<div class="search-jsj-tatle">
		<div style="display: flex;">
			<el-button @click="initVehicleCalendar" type="primary" round>新增车辆日历</el-button>
			<el-input
			  v-model="key"
			  placeholder="请输入搜索关键词"
			  class="input-with-select"
			>
			  <template #append>
			    <el-button @click="fetchOrders" icon="Search" />
			  </template>
			</el-input>
		</div>
	</div>
	<el-table :data="tableData" style="width: 100%" height="680">
	    <el-table-column fixed prop="rq" label="日期" width="320" />
	    <el-table-column fixed prop="cxh9" label="豪华9" width="200" />
	    <el-table-column prop="cxh7" label="豪华7" width="200" />
		<el-table-column prop="cxs11" label="舒适11" width="200" />
		<el-table-column prop="cxs5" label="舒适5" width="200" />
	    <el-table-column fixed="right" label="操作" width="*">
	      <template #default="scope">
	        <el-button link type="primary" size="small" @click="handleDtClick(scope.row)">详情</el-button>
			<el-button link type="primary" size="small" @click="deleteData(scope.row)">删除</el-button>
	      </template>
	    </el-table-column>
	</el-table>
	<div class="pagination-custom">
		<el-pagination :page-size="20" @current-change="changePageNo" background layout="pager" :total="total" />
	</div>
	<el-dialog
		@close="closeDtDialog"
	    v-model="jsjDialogVisible"
	    title="修改日历"
	    width="50%"
	    destroy-on-close
		:modal="false"
	>	
		<el-form
			ref="form"
			:model="orderForm"
			label-width="auto"
			:label-position="labelPosition"
			:size="size"
		>
			<div style="display: flex;">
				<el-form-item label="日期" style="width: 96%;">
				  <el-date-picker
					  v-model="orderForm.rq"
					  type="date"
					  placeholder="请选择日期"
					  :size="size"
					/>
				</el-form-item>
			</div>
			<div style="display: flex;">
				<el-form-item label="豪华9" style="width: 48%;">
				  <el-input class="w-50 m-2" v-model="orderForm.cxh9" />
				</el-form-item>
				<el-form-item label="豪华7" style="width: 48%;">
				  <el-input class="w-50 m-2" v-model="orderForm.cxh7" />
				</el-form-item>
			</div>
			<div style="display: flex;">
				<el-form-item label="舒适11" style="width: 48%;">
				  <el-input class="w-50 m-2" v-model="orderForm.cxs11" />
				</el-form-item>
				<el-form-item label="舒5" style="width: 48%;">
				  <el-input  class="w-50 m-2" v-model="orderForm.cxs5" />
				</el-form-item>
			</div>
		</el-form>
		<template #footer>
		  <span class="dialog-footer">
		    <el-button @click="closeDtDialog">关闭</el-button>
		    <el-button type="primary" @click="saveForm">保存</el-button>
		  </span>
		</template>
	</el-dialog>
</template>

<script setup>
	import { ref,provide,inject,onMounted } from 'vue';
	import axios from 'axios';
	import { useMemberStore } from '../../stores';
	import { ElMessage } from 'element-plus'
	import { useRoute, useRouter } from 'vue-router'
	const userStore = useMemberStore();
	const router = useRouter();
	const size = ref('default')
	const labelPosition = ref('right')
	const key = ref('')
	const pageNo = ref(1);
	const pageSize = ref(20);
	const total = ref(0);
	const tableData = ref([]);
	const jsjDialogVisible = ref(false);//详情
	const billid = ref('');
	const orderForm = ref({
		rq:'',
		cxh9:1,
		cxh7:1,
		cxs11:7,
		cxs5:0,
	})
	const initVehicleCalendar=()=>{
		router.push('/car/car-calendar-add');
	}
	onMounted(async()=>{
		const response = await axios.post('/manageCar/carCalendar/queryList', {
		  pageNo:pageNo.value,
		  pageSize:pageSize.value,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			tableData.value = response.data.data;
			total.value = response.data.total;
		}
	})

	const fetchOrders = async () => {
		const response = await axios.post('/manageCar/carCalendar/queryList', {
		  value:key.value,
		  key:'rq',
		  pageNo:pageNo.value,
		  pageSize:pageSize.value,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			tableData.value = response.data.data;
			total.value = response.data.total;
		}
	};
	const handleDtClick = async(e)=>{
		billid.value = e.id;
		const response = await axios.post('/manageCar/carCalendar/queryInfo', {
		  billid:e.id,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			orderForm.value = response.data.data
		}else{
			ElMessage.error('哦,车辆日历失败!')
		}
		jsjDialogVisible.value = true;
	}
	const deleteData=async(e)=>{
		const response = await axios.post('/manageCar/carCalendar/del', {
		  billid:e.id,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage({
				message: '删除成功!',
				type: 'success',
			})
			fetchOrders()
		}
		
	}
	const changePageNo = (val) => {
		pageNo.value = val;
		fetchOrders();
	}
	const closeDtDialog=()=>{
		jsjDialogVisible.value = false;
	}
	const editForm = ()=>{
		
	}
	const saveForm = async () =>{
		const response = await axios.post('/manageCar/carCalendar/update', {
		  billid:billid.value,
		  ...orderForm.value
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage({
				message: '信息保存成功!',
				type: 'success',
			})
			tableData.value.map(item=>{
				if(item.id===billid.value){
					item.cxh9 = orderForm.value.cxh9;
					item.cxh7 = orderForm.value.cxh7;
					item.cxs11 = orderForm.value.cxs11;
					item.cxs5 = orderForm.value.cxs5;
				}
			})
		}else{
			ElMessage.error('哦,信息保存失败!')
		}
		jsjDialogVisible.value = false;
	}
</script>

<style scoped>
	.pagination-custom{
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin: 10px 0;
	}
	.search-jsj-tatle{
		float: right;
		width: 50%;
		margin: 0 0 10px 0;
	}
	.dialog-cond-dt{
		margin: 0 0 0 20px;
	}
	.dialog-cond-label{
		margin: 0 5px;
	}
</style>